export const SET_OTHERS_DATA = 'SET_OTHERS_DATA';
export const setOthersData = (data, count) => ({
  type: SET_OTHERS_DATA,
  payload: { data, count }
});